import React from "react";
import styled, { createGlobalStyle, css } from "styled-components";
import { ReactComponent as InformationSVG } from "../../assets/svg/notification-information.svg";

const Reviewed = ({ message = "Revisaron tu carta!", onClick = () => {} }) => (
  <>
    <ToastContainer>
      <ToastIcon as={InformationSVG} />
      <ToastLabel>{message}</ToastLabel>
      <ToastButton onClick={onClick}>Ver</ToastButton>
    </ToastContainer>
  </>
);

const ToastContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`;

const ToastIcon = styled.div`
  width: 25px;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
  fill: #32b0ea;
`;

const ToastLabel = styled.div`
  margin: 0px 15px;
`;

const ToastButton = styled.div`
  border-radius: 15px;
  background-color: #32b0ea;
  color: white;
  padding: 10px 15px;

  min-width: 50px;

  margin-left: auto;

  text-align: center;
`;

export default Reviewed;
